import { toast } from 'react-toastify';
import { format } from 'date-fns';
import api, { cardeal } from './api';

export class TransformacaoBeneficioService {
  getDadosTransformacaoBeneficio = async (matricula, plano) => {
    const response = await cardeal.get('ObtemDadosTransformacaoBeneficio', {
      params: {
        matricula,
        plano,
      },
    });
    if (
      response.data.ObtemDadosTransformacaoBeneficioResult.MsgConsistencia !==
        '' &&
      response.data.ObtemDadosTransformacaoBeneficioResult.CdConsistencia !==
        '6' &&
      response.data.ObtemDadosTransformacaoBeneficioResult.CdConsistencia !==
        '7' &&
      parseInt(
        response.data.ObtemDadosTransformacaoBeneficioResult.CdConsistencia,
        10
      ) >= 2
    ) {
      return {
        codConsistencia:
          response.data.ObtemDadosTransformacaoBeneficioResult.CdConsistencia,
        mensagemAviso:
          response.data.ObtemDadosTransformacaoBeneficioResult.MsgConsistencia,
      };
    }

    const valorPercRendaSolForm =
      response.data.ObtemDadosTransformacaoBeneficioResult.PercRendaSol.replace(
        ',',
        '.'
      );

    const objetoRetorno = {
      codConsistencia:
        response.data.ObtemDadosTransformacaoBeneficioResult.CdConsistencia,
      tipoBeneficio:
        response.data.ObtemDadosTransformacaoBeneficioResult.Tipobenef,
      formaRecebimento:
        response.data.ObtemDadosTransformacaoBeneficioResult.FormaRec,
      pessoasGrupoFamiliar: response.data.Reserva[0]?.QUANTIDADE_GRUPO || 0,
      reservaMatematica: response.data.Reserva[0]?.RESERVA,
      dataSolicitacao: response.data.ObtemDadosTransformacaoBeneficioResult
        .DataRegSol
        ? response.data.ObtemDadosTransformacaoBeneficioResult.DataRegSol
        : '-',
      statusSolicitacao: response.data.Reserva[0].StatusAceite
        ? response.data.Reserva[0].StatusAceite
        : '-',
      percentualRecebimento:
        response.data.ObtemDadosTransformacaoBeneficioResult.PercRendaSol,
      valorRendaPosTransf:
        parseFloat(valorPercRendaSolForm) *
        (response.data.Reserva[0].RESERVA / 100),
      mensagemAviso:
        response.data.ObtemDadosTransformacaoBeneficioResult.MsgConsistencia,
      protocolo: response.data.Reserva[0]?.Protocolo,
    };

    return objetoRetorno;
  };

  setSolicitacaoTransformacaoBeneficio = async (params) => {
    const response = await cardeal.post(
      'RegistrarSolicitacaoTransformacaoBenefico',
      {
        matricula: params.matricula,
        reserva: params.reserva,
        percentual: params.percentual,
        renda: params.renda,
      }
    );
    return response.data.RegistrarSolicitacaoTransformacaoBeneficoResult.Value;
  };

  getReservaMatematica = async (params) => {
    const response = await cardeal.get('ObterReservaMatematica', {
      params: { matricula: params.matricula, plano: params.plano },
    });

    return response.data;
  };

  getCalculoExaurimento = async (params) => {
    const response = await cardeal.get('CalcularExaurimentoPorPlano', {
      params: { ...params },
    });

    return response.data;
  };

  setSolicitacaoTransformacaoBeneficioPlanoA = async (params) => {
    const response = await cardeal.get(
      'RegistrarTransformacaoBeneficioPlanoA',
      {
        params: {
          matricula: params.matricula,
          parcelaAdicional: params.parcelaAdicional,
          saqueVista: params.percentualRetiradaVista,
          percentual: params.percentualRendaMensal,
        },
      }
    );

    return response.data;
  };

  getLimitesSaudeFinanceira = async () => {
    const response = await api.get('ObterLimitesSaudeFinanceira');

    return response.data;
  };

  obterSaibaMaisSaudeFinanceira = async () => {
    try {
      const response = await api.get(
        'ObterLayoutPaginaFiltro?Identificador=saude-financeira'
      );

      return response.data.results[0];
    } catch (e) {
      toast.error('Erro ao obter saiba mais de saúde financeira');

      return '';
    }
  };

  getPdfTabelaExaurimento = async (params, token) => {
    const response = await api.get('GerarTabelaExaurimentoPDF', {
      params: {
        ...params,
        token,
        dtGeracao: format(new Date(), "dd/MM/yyyy 'às' HH:mm"),
      },
    });

    return response.data;
  };
}
